/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const WholesaleDigitalMenuPage = lazyLoad(
  () => import('./index'),
  module => module.WholesaleDigitalMenuPage
);
